import { createContext, useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';

import * as jwt_decode from 'jwt-decode';
import api from '../core/axiosInstance';

const AuthContext = createContext();

export const AuthProvider = ({ children }) => {
  const [user, setUser] = useState(null);
  const [token, setToken] = useState(localStorage.getItem('token') || '');
  const [lineId, setLineId] = useState(localStorage.getItem('x-line-id') || '');
  const navigate = useNavigate();

  useEffect(() => {
    if (token) {
      try {
        // const decoded = jwt_decode(token);
        // setUser(decoded);
      } catch (error) {
        console.error('Invalid token');
        logout();
      }
    }
  }, [token]);

  const login = async (username, password, lineId) => {
    try {
      const { data } = await api.post('/api/auth/member/token', {
        username,
        password,
        lineId,
      });
      localStorage.setItem('token', data.token);
      setToken(data.token);
      localStorage.setItem('x-line-id', lineId);
      return Promise.resolve(data); // Explicitly return a resolved promise
    } catch (error) {
      alert(error.response.data.message);
      console.error('Login failed', error);
      return Promise.reject(error); // Return a rejected promise for error handling
    }
  };

  const loginLineToken = async (lineToken) => {
    try {
      const { data } = await api.post('/api/auth/member/token', {
        lineToken,
      });
      localStorage.setItem('token', data.token);
      setToken(data.token);

      return Promise.resolve(data); // Explicitly return a resolved promise
    } catch (error) {
      console.error('Login failed', error);
      return Promise.reject(error); // Return a rejected promise for error handling
    }
  };

  const logout = () => {
    localStorage.removeItem('token');
    setToken('');
    setUser(null);
    navigate('/login');
  };

  return (
    <AuthContext.Provider
      value={{ user, token, login, logout, loginLineToken, setLineId, lineId }}
    >
      {children}
    </AuthContext.Provider>
  );
};

export default AuthContext;
